import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 h-100" }
const _hoisted_2 = ["data"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("object", {
      type: "application/pdf",
      data: `${_ctx.objectUrl}#toolbar=${_ctx.toolBar ? '1' : '0'}&navpanes=0&view=FitH`,
      class: "w-100 h-100"
    }, null, 8, _hoisted_2)
  ]))
}